import React, { useState, useEffect } from "react";
import { Box } from "@mui/system";
import {
  Card,
  CardActionArea,
  CardMedia,
  Typography,
  CardContent,
} from "@vapor/v3-components";
import { LinkDocument } from "./LinkDocument";
import { CardDocument } from "./CardDocument ";
import { Attached } from "../services/Models/BaseModel";
import { getFileExtension } from "../utils/util";

interface PreviewCardProps {
  title: string;
  image: string;
  previewImage: string;
  index: number;
  doc: Attached;
  noDownloadVideo: boolean;
  onClick: () => void;
}

export const PreviewCard: React.FC<PreviewCardProps> = ({
  title,
  image,
  previewImage,
  index,
  doc,
  noDownloadVideo,
  onClick,
}) => {
  const [svgContent, setSvgContent] = useState<string | null>(null);
  const [hovered, setHovered] = useState(false);

  useEffect(() => {
    // Fetch del file SVG dal server
    fetch(image)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Failed to load SVG: ${response.statusText}`);
        }
        return response.text();
      })
      .then((data) => {
        // Inserisce il contenuto dell'SVG nel componente
        setSvgContent(data);
      })
      .catch((error) => {
        console.error("Error loading SVG:", error);
        setSvgContent(null);
      });
  }, [image]);

  const handleMouseOver = () => setHovered(true);
  const handleMouseOut = () => setHovered(false);

  return (
    <Card
      variant="outlined"
      sx={{
        width: "190px", // Imposta la larghezza dinamica
        height: "240px",
      }}
    >
      <CardContent sx={{ padding: 1 }}>
        <CardActionArea sx={{ padding: 0 }} onClick={() => onClick()}>
          <CardDocument
            index={index}
            documentPreview={window.config.BASE_URL + previewImage}
            documentUrl={
              !doc
                ? window.config.BASE_URL + previewImage
                : doc.DocumentType === "LINK" || doc.DocumentType === "YOUTUBE"
                ? doc.LinkUrl
                : window.config.BASE_URL +
                  "/preview/" +
                  doc.MD5 +
                  "." +
                  doc.DocumentType
            }
            documentType={
              !doc ? getFileExtension(previewImage, true)! : doc.DocumentType
            }
            onClick={onClick}
            noDownloadVideo={noDownloadVideo}
          />
          <Box
            sx={{ textAlign: "center" }}
            // sx={{ p: 2 }}
          >
            <Typography color="#101214" mb={1} variant="bodySmallRegular">
              {title}
            </Typography>
          </Box>
        </CardActionArea>
      </CardContent>
    </Card>
  );
};
